import React, { useState, useEffect } from 'react';
import { Row, Col, Form, Button, Spinner, } from 'react-bootstrap';

const ProfileDetails = ({ userDetails, editMode, onSave, onCancel, loading }) => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    Email: '',
    CountryCode: '',
    MobileNumber: '',
    Country: '',
    Region: ''
  });

  const [countries, setCountries] = useState([]);

  // Load countries data
  useEffect(() => {
    const countryData = {
      "Afghanistan": "93",
      "Albania": "355",
      "Algeria": "213",
      "Andorra": "376",
      "Angola": "244",
      "Argentina": "54",
      "Armenia": "374",
      "Australia": "61",
      "Austria": "43",
      "Azerbaijan": "994",
      "Bahamas": "1-242",
      "Bahrain": "973",
      "Bangladesh": "880",
      "Barbados": "1-246",
      "Belarus": "375",
      "Belgium": "32",
      "Belize": "501",
      "Benin": "229",
      "Bhutan": "975",
      "Bolivia": "591",
      "Bosnia and Herzegovina": "387",
      "Botswana": "267",
      "Brazil": "55",
      "Brunei": "673",
      "Bulgaria": "359",
      "Burkina Faso": "226",
      "Burundi": "257",
      "Cabo Verde": "238",
      "Cambodia": "855",
      "Cameroon": "237",
      "Canada": "1",
      "South Africa": "27",
      "United Kingdom": "44",
      "United States": "1"
      // Add more countries as needed (this is a subset)
    };

    setCountries(Object.keys(countryData).sort());
  }, []);

  // Update formData when userDetails changes
  useEffect(() => {
    if (userDetails) {
      const { firstName, lastName } = parseFullName(userDetails.FullName);

      setFormData({
        firstName,
        lastName,
        Email: userDetails.Email || '',
        CountryCode: userDetails.CountryCode || '',
        MobileNumber: userDetails.MobileNumber || '',
        Country: userDetails.Country || '',
        Region: userDetails.Region || ''
      });
    }
  }, [userDetails]);

  const parseFullName = (fullName) => {
  if (!fullName || fullName.trim() === '') {
    return { firstName: '', lastName: '' };
  }

  const trimmedName = fullName.trim();
  const nameParts = trimmedName.split(' ').filter(part => part.length > 0);
  
  if (nameParts.length === 0) {
    return { firstName: '', lastName: '' };
  } else if (nameParts.length === 1) {
    // Only one part, put it all in firstName
    return { firstName: nameParts[0], lastName: '' };
  } else {
    // Multiple parts: last part is lastName, everything else is firstName
    const lastName = nameParts[nameParts.length - 1];
    const firstName = nameParts.slice(0, -1).join(' ');
    return { firstName, lastName };
  }
};

  // Handle form input changes
  const handleChange = (e) => {
    const { name, value } = e.target;

    // Special handling for CountryCode to only allow numbers
    if (name === 'CountryCode') {
      const numericValue = value.replace(/\D/g, '');
      setFormData({ ...formData, [name]: numericValue });
    }
    // Special handling for MobileNumber to only allow numbers
    else if (name === 'MobileNumber') {
      const numericValue = value.replace(/\D/g, '');
      setFormData({ ...formData, [name]: numericValue });
    }

    else if (name === 'firstName') {
      // Prevent spaces at the end and clean up multiple spaces
      const cleanValue = value.replace(/\s+/g, ' ');
      setFormData({ ...formData, [name]: cleanValue });
    }
    else if (name === 'lastName') {
      // Clean up multiple spaces
      const cleanValue = value.replace(/\s+/g, ' ');
      setFormData({ ...formData, [name]: cleanValue });
    }
    else {
      setFormData({ ...formData, [name]: value });
    }
  };

  // Handle form submission
  const handleSubmit = (e) => {
  e.preventDefault();

  // Clean and validate the names
  const cleanFirstName = formData.firstName.trim();
  const cleanLastName = formData.lastName.trim();

  // Validation
  if (!cleanFirstName) {
    alert('First name is required');
    return;
  }

  // Combine first and last name with proper spacing
  const FullName = cleanLastName 
    ? `${cleanFirstName} ${cleanLastName}` 
    : cleanFirstName;

  // Prepare data for API (rest remains the same)
  const userData = {
    FullName,
    Email: formData.Email,
    CountryCode: formData.CountryCode,
    MobileNumber: formData.MobileNumber,
    Country: formData.Country,
    Region: formData.Region
  };

  onSave(userData, e);
};

  // Parse user details for display
  const displayUserDetails = () => {
  if (!userDetails) return { name: '', lastName: '', number: '', email: '', country: '', region: '' };

  const { firstName, lastName } = parseFullName(userDetails.FullName);

  return {
    name: firstName,
    lastName: lastName,
    number: userDetails.CountryCode && userDetails.MobileNumber ?
      `+${userDetails.CountryCode} ${userDetails.MobileNumber}` : '',
    email: userDetails.Email || '',
    country: userDetails.Country || '',
    region: userDetails.Region || ''
  };
};

  const userDisplayData = displayUserDetails();

  return (
    <>
      {loading ? (
        <div className="text-center py-4">
          <Spinner animation="border" role="status" variant="success" size="md" />
          <p className="mt-2">Loading profile data...</p>
        </div>
      ) : (
        <>
          {!editMode ? (
            // View Mode
            <div id="view-mode" className="justify-content-center">
              <Row>
                <Col md={5} className="mb-4">
                  <div className="profile-field">
                    <label className="d-block text-black mb-2">First Name</label>
                    <div className="text-display">{userDisplayData.name || '-'}</div>
                  </div>
                </Col>

                <Col md={5} className="mb-4">
                  <div className="profile-field">
                    <label className="d-block text-black mb-2">Last Name</label>
                    <div className="text-display">{userDisplayData.lastName || '-'}</div>
                  </div>
                </Col>

                <Col md={5} className="mb-4">
                  <div className="profile-field">
                    <label className="d-block text-black mb-2">Email</label>
                    <div className="text-display">{userDisplayData.email || '-'}</div>
                  </div>
                </Col>
                <Col md={5} className="mb-4">
                  <div className="profile-field">
                    <label className="d-block text-black mb-2">Mobile Number</label>
                    <div className="text-display">{userDisplayData.number || '-'}</div>
                  </div>
                </Col>
              </Row>

              <Row>


                <Col md={5} className="mb-4">
                  <div className="profile-field">
                    <label className="d-block text-black mb-2">Country</label>
                    <div className="text-display">{userDisplayData.country || '-'}</div>
                  </div>
                </Col>

                <Col md={5} className="mb-4">
                  <div className="profile-field">
                    <label className="d-block text-black mb-2">State/Region</label>
                    <div className="text-display">{userDisplayData.region || '-'}</div>
                  </div>
                </Col>
              </Row>
            </div>
          ) : (
            // Edit Mode
            <Form onSubmit={handleSubmit}>
              <Row className="justify-content-center">
                <Col md={5} className="mb-4">
                  <div className="profile-field">
                    <Form.Label className="d-block text-black mb-2">First Name</Form.Label>
                    <Form.Control
                      type="text"
                      name="firstName"
                      value={formData.firstName}
                      onChange={handleChange}
                      placeholder="First name"
                      required
                      className="edit-control"
                    />
                  </div>
                </Col>

                <Col md={5} className="mb-4">
                  <div className="profile-field">
                    <Form.Label className="d-block text-black mb-2">Last Name</Form.Label>
                    <Form.Control
                      type="text"
                      name="lastName"
                      value={formData.lastName}
                      onChange={handleChange}
                      placeholder="Last name"
                      required
                      className="edit-control"
                    />
                  </div>
                </Col>

                <Col md={5} className="mb-4">
                  <div className="profile-field">
                    <Form.Label className="d-block text-black mb-2">Email</Form.Label>
                    <Form.Control
                      type="email"
                      name="Email"
                      value={formData.Email}
                      readOnly
                      disabled
                      className="edit-control disabled"
                    />
                    <Form.Text className="text-black small mt-2">
                      To change your email, use the Email change option in Security settings.
                    </Form.Text>
                  </div>
                </Col>

                <Col md={5} className="mb-4">
                  <div className="profile-field">
                    <Form.Label className="d-block text-black mb-2">Mobile Number</Form.Label>
                    <div className="d-flex">
                      <div className="country-code-container">
                        <div className="input-group-text">+</div>
                        <Form.Control
                          type="text"
                          name="CountryCode"
                          value={formData.CountryCode}
                          onChange={handleChange}
                          placeholder="Code"
                          maxLength={5}
                          className="country-code-input edit-control"
                        />
                      </div>
                      <Form.Control
                        type="tel"
                        name="MobileNumber"
                        value={formData.MobileNumber}
                        onChange={handleChange}
                        placeholder="Enter phone number"
                        className="flex-grow-1 edit-control"
                      />
                    </div>
                  </div>
                </Col>
              </Row>

              <Row className="justify-content-center">
                <Col md={5} className="mb-4">
                  <div className="profile-field">
                    <Form.Label className="d-block text-black mb-2">Country</Form.Label>
                    <Form.Control
                      as="select"
                      name="Country"
                      value={formData.Country}
                      onChange={handleChange}
                      className="edit-control custom-select"
                    >
                      <option value="" disabled>Select Country</option>
                      {countries.map(country => (
                        <option key={country} value={country}>{country}</option>
                      ))}
                    </Form.Control>
                  </div>
                </Col>

                <Col md={5} className="mb-4">
                  <div className="profile-field">
                    <Form.Label className="d-block text-black mb-2">State/Region</Form.Label>
                    <Form.Control
                      type="text"
                      name="Region"
                      value={formData.Region}
                      onChange={handleChange}
                      placeholder="State/Region"
                      className="edit-control"
                    />
                  </div>
                </Col>
              </Row>

              <div className="d-flex justify-content-center mt-3 mb-2">
                <Button
                  variant="success"
                  type="submit"
                  disabled={loading}
                  className="btn-action mr-3"
                >
                  {loading ? (
                    <>
                      <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="mr-2" />
                      Saving...
                    </>
                  ) : (
                    <>
                      <i className="fas fa-save mr-2"></i>
                      Save Changes
                    </>
                  )}
                </Button>
                <Button
                  variant="outline-secondary"
                  onClick={onCancel}
                  disabled={loading}
                  className="btn-action"
                >
                  <i className="fas fa-times mr-2"></i>
                  Cancel
                </Button>
              </div>
            </Form>
          )}
        </>
      )}
    </>
  );
};

export default ProfileDetails;